import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=4c8af80b"
import script from "./radio.vue?vue&type=script&lang=js"
export * from "./radio.vue?vue&type=script&lang=js"
import style0 from "./radio.vue?vue&type=style&index=0&id=4c8af80b&prod&lang=css"
import style1 from "./radio.vue?vue&type=style&index=1&id=4c8af80b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports